import { GraduationCap, HeartPulse, HandCoins } from "lucide-react";
import { Reveal, MaskLine } from "./shared";
import { useLang } from "@/i18n";

const icons = [GraduationCap, HeartPulse, HandCoins];
const pillarIds = ["education", "health", "livelihood"];

export default function Impact() {
  const { t } = useLang();
  const pillars = t("impact.pillars");

  return (
    <section id="impact" className="bg-ink py-24 text-cream lg:py-32" data-testid="impact-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-mustard">{t("impact.overline")}</p>
        <h2 className="mt-6 max-w-3xl font-serif text-4xl font-medium leading-tight tracking-tight sm:text-5xl">
          <MaskLine>{t("impact.line1")}</MaskLine>
          <MaskLine delay={0.12}>
            <span className="italic text-ochre">{t("impact.line2")}</span>
          </MaskLine>
          <MaskLine delay={0.24}>{t("impact.line3")}</MaskLine>
        </h2>

        <Reveal className="mt-14">
          <div className="grid max-w-3xl grid-cols-2 gap-4 lg:gap-6" data-testid="impact-photos">
            <div className="arch-frame overflow-hidden border border-cream/15">
              <img
                src="/assets/farm/training-session.jpeg"
                alt="A training and exposure session for the producer group"
                className="aspect-[3/4] w-full object-cover transition-transform duration-700 ease-out hover:scale-105"
                loading="lazy"
              />
            </div>
            <div className="mt-8 overflow-hidden border border-cream/15">
              <img
                src="/assets/farm/inauguration-coconut.jpeg"
                alt="Breaking the coconut at the unit inauguration"
                className="aspect-[3/4] w-full object-cover transition-transform duration-700 ease-out hover:scale-105"
                loading="lazy"
              />
            </div>
          </div>
          <p className="mt-4 text-xs uppercase tracking-[0.18em] text-cream/50">{t("extras.impactCaption")}</p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-px overflow-hidden border border-cream/10 bg-cream/10 sm:grid-cols-3">
          {pillars.map((p, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={p.title} delay={i * 0.1} className="group bg-ink p-10 transition-colors duration-500 hover:bg-olive">
                <div data-testid={`impact-pillar-${pillarIds[i]}`}>
                  <Icon className="h-7 w-7 text-mustard transition-transform duration-500 group-hover:-translate-y-1" />
                  <h3 className="mt-6 font-serif text-2xl font-semibold tracking-tight">{p.title}</h3>
                  <p className="mt-3 text-sm font-light leading-relaxed text-cream/70">{p.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
